
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(380|40|639|904)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
